import {
  GetDisplayOptionsRawResponse,
  GetDisplayOptionsResponse,
  UpdateDisplayOptionsRawResponse,
  UpdateDisplayOptionsResponse,
} from "./types";

export const transformDisplayOptions = (res: GetDisplayOptionsRawResponse) => {
  const { _links, ...displayOptions } = res;
  const response: GetDisplayOptionsResponse = {
    data: {
      details: {
        bookingMaxNumberOfStops: displayOptions.enabled_booking_max_number_of_stops,
        enabledBookingHistoryDisplayOperatorIdentifier: Boolean(displayOptions.enabled_booking_history_display_operator_identifier),
        enabledBookingHistoryUseOptimizedWideDisplay: Boolean(displayOptions.enabled_booking_history_use_optimized_wide_display),
        enabledBookingManagerDashboardNoteFunctionality: Boolean(displayOptions.enabled_booking_manager_dashboard_note_functionality),
      },
    },
    links: _links,
  };

  return response;
};

export const transformUpdateDisplayOptions = (res: UpdateDisplayOptionsRawResponse) => {
  return {
    links: res._links,
  } as UpdateDisplayOptionsResponse;
};
